import React from "react";
import Styles from "./Styles";
import { isEmpty } from "../../../utils/comm";

const ServiceInfo = ({ children }) => {
  if (!isEmpty(children)) {
    return (
      <Styles className='service-info'>
        {children.corpNm}&ensp;{!isEmpty(children.corpNm) && "》"}&ensp;{children.corpSevNm}
      </Styles>
    );
  } else {
    return <Styles className='service-info' />;
  }
};
export default ServiceInfo;
